import {forwardRef, ForwardedRef, ReactNode} from "react";
import FaiBadgeRoot from "./FaiBadgeRoot";

interface FaiBadgeProps {
    color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";
    variant?: "gradient" | "contained";
    size?: "xs" | "sm" | "md" | "lg";
    circular?: boolean;
    indicator?: boolean;
    border?: boolean;
    children?: ReactNode;
    container?: boolean;

    [key: string]: any;
}

const FaiBadge = forwardRef((props: FaiBadgeProps, ref: ForwardedRef<any>) => {
    const {
        color = "info",
        variant = "gradient",
        size = "sm",
        circular = false,
        indicator = false,
        border = false,
        children = false,
        container = false,
        ...rest
    } = props;

    return (
        <FaiBadgeRoot
            {...rest}
            ownerState={{color, variant, size, circular, indicator, border, container, children}}
            ref={ref}
            color="default"
        >
            {children}
        </FaiBadgeRoot>
    );
});

export default FaiBadge;
